
import { useEffect } from "react";

export default function TransactionDetails({ request, bill, totalPrice, hasWarranty, applyTax, freightPrice, partPrice, WarrantyPrice }) {

  useEffect(() => { }, [bill])
  // console.log("REQUEST_____", request)
  // console.log("Billlll______", bill)
  // console.log("Has_warranty", hasWarranty)
  // console.log("ApplyTax", applyTax)
  // console.log("TotalPrice", totalPrice)
  // console.log("Freightprice", freightPrice)
  // console.log("Freightprice", partPrice)
  // console.log(
  //   "Subtotal Calculation:",
  //   partPrice > 0 ? "$" + (partPrice * request?.quantity).toFixed(2) : "$00"
  // );
  return (
    <>
      <div>
        <p className="text-base mt-4 font-semibold">Transaction:</p>
      </div>
      <div>
        <div className="mx-2 sm:mx-6 border-b-1 border-gray-300 pb-1 grid grid-cols-2">
          <div className="text-left leading-7 font-semibold text-sm">
            <p>Subtotal x {request?.quantity}</p>

            <p>
              {/* Shipping Cost <span className="text-xs">(Inc GST)</span> */}

              FreightPrice <span className="text-xs"></span>
            </p>
            <p>Warranty</p>
            <p>Tax (Inc GST)</p>
          </div>
          <div className="text-right leading-7 text-sm">
            <p>
              {partPrice > 0
                ? "$" + (partPrice * request?.quantity).toFixed(2)
                : "$00"}
            </p>
            <p>${freightPrice ? Number(freightPrice).toFixed(2) : "0.00"}</p>
            {/* <p>{hasWarranty && bill.warrantyPrice ? "$" + bill.warrantyPrice : "$00"}</p> */}
            <p>{WarrantyPrice ? `$${Number(WarrantyPrice).toFixed(2)}` : "$0.00"}</p>
            <p>
              {applyTax
                ? `$${Math.round(
                  (bill.partPrice * request?.quantity * 0.10 || 0) +
                  (bill.freightPrice * 0.10 || 0)
                )}.00`
                : "Inclusive"}
            </p>
          </div>
        </div>
        <div className="flex justify-between mx-2 sm:mx-6 py-2 text-base font-semibold">
          <div>
            <p>Grand Total</p>
          </div>
          <div>
            <p>
              {/* {bill.totalPrice > 0 ? "$" + bill.totalPrice : "$00"} */}
              {"$" + Number(totalPrice).toFixed(2)}
              </p>
          </div>
        </div>
      </div>
    </>
  );
}
